import React from 'react';
import { useMainClock } from './clock';
import { MainClockContext } from './context';

export type MainClockProviderProps = {
  children: React.ReactNode;
};

export const MainClockProvider: React.FC<{ children: React.ReactNode }> = (props) => {
  const clock = useMainClock();

  return (
    <MainClockContext.Provider value={clock}>
      {props.children}
    </MainClockContext.Provider>
  );
};
